import React from "react";
import { Select, Typography } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";

const { Option } = Select;

const SelectOffice = ({
  offices = [],
  selectedOfficeIds = [],
  onOfficeChange,
  placeholder = "Select offices...",
  label = "Select Offices",
  labelStyle = { fontSize: "21px", fontWeight: 500 },
  selectStyle = { width: 420, height: 36, borderRadius: 8, color: "#6b43b5", transform: "scale(1.16)", transformOrigin: "left top" },
}) => {
  const allIds = offices.map((o) => o.id);

  const handleOfficeChange = (selectedStringValues) => {
    if (selectedStringValues.includes("all")) {
      // Toggle select all / unselect all
      if (selectedOfficeIds.length === allIds.length) {
        onOfficeChange([]);
      } else {
        onOfficeChange(allIds);
      }
    } else {
      const integerValues = selectedStringValues.map((val) => parseInt(val, 10));
      onOfficeChange(integerValues);
    }
  };

  return (
    <div className="div-start" style={{ marginBottom: 50 }}>
      <Typography style={labelStyle}>{label}</Typography>
      <Select
        mode="multiple"
        value={selectedOfficeIds.map((id) => id.toString())}
        onChange={handleOfficeChange}
        style={selectStyle}
        maxTagCount={2}
        // suffixIcon={<CaretDownOutlined style={{ color: '#6b43b5' }} />}
        placeholder={placeholder}
      >
        <Option key="all" value="all">
          {selectedOfficeIds.length === allIds.length ? "Unselect All" : "Select All"}
        </Option>
        {offices.map((office) => (
          <Option key={office.id} value={office.id.toString()}>
            {office.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectOffice;
